export default __webpack_public_path__ + "7e55fee37461b3e13aec550062a80567.png";